import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatLongNote',
  standalone: true
})
export class FormatLongNotePipe implements PipeTransform {

  transform(value: string | undefined | null, separator?: string ): unknown {
    const stringSeparator = separator ?? ' - ';

    if(!value) return;

    if(value.toString().includes(stringSeparator)){
      const tokens = value.split('-');
      let formattedValue = "<ul class='list-none p-0 m-0'>";
      tokens.map(e => e.trim()).filter(e => e).forEach((e, i) => {
        if(i < tokens.length - 1){
          formattedValue += `<li class='mb-2 pb-1 border-dashed border-none border-bottom-1 border-bluegray-200'>${e}</li>`;
        }else{
          formattedValue += `<li>${e}</li>`;
        }
      });
      formattedValue += '</ul>';

      return formattedValue;
    }
    return value;
  }
}
